export default __webpack_public_path__ + "static/colibri-3-web-dc8132469073b103bcc05f3f7e8ea4bc.pdf";